import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import propTypes from 'prop-types';
import { BrowserRouter as ReactRouterBrowserRouter, Routes as ReactRouterRoutes, Route as ReactRouterRoute, Navigate as ReactRouterNavigate } from 'react-router-dom';
import { isDefined } from '@dateam/ark';
import { GuardContext } from './contexts';
import { useRouterRegistration } from './hooks';
import Route from './Route';
var Router = function Router(_ref) {
  var router = _ref.router,
    children = _ref.children;
  var _useRouterRegistratio = useRouterRegistration(router),
    _useRouterRegistratio2 = _slicedToArray(_useRouterRegistratio, 1),
    registeredRouter = _useRouterRegistratio2[0];
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    routes = _React$useState2[0],
    setRoutes = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    otherwisePath = _React$useState4[0],
    setOtherwisePath = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isReady = _React$useState6[0],
    setIsReady = _React$useState6[1];
  React.useEffect(function () {
    if (isDefined(registeredRouter)) {
      var _routes = registeredRouter.generateRoutes();
      setRoutes(_routes);
      setOtherwisePath(registeredRouter.otherwisePath);
    }
    setIsReady(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isReady) return null;
  return /*#__PURE__*/React.createElement(ReactRouterBrowserRouter, null, children, /*#__PURE__*/React.createElement(ReactRouterRoutes, null, routes.map(function (route) {
    var key = route.key,
      path = route.path,
      component = route.component,
      metadata = route.metadata,
      exact = route.exact,
      redirect = route.redirect,
      layout = route.layout,
      layoutData = route.layoutData,
      guards = route.guards;
    var options = {
      key: key,
      layout: layout,
      layoutData: layoutData,
      redirect: redirect
    };
    return /*#__PURE__*/React.createElement(ReactRouterRoute, {
      key: key,
      path: path,
      element: /*#__PURE__*/React.createElement(GuardContext.Provider, {
        value: guards
      }, /*#__PURE__*/React.createElement(Route, {
        path: path,
        exact: exact,
        component: component,
        options: options,
        metadata: metadata
      }))
    });
  }), /*#__PURE__*/React.createElement(ReactRouterRoute, {
    key: "404",
    index: true,
    path: "*",
    element: /*#__PURE__*/React.createElement(ReactRouterNavigate, {
      to: otherwisePath
    })
  })));
};
process.env.NODE_ENV !== "production" ? Router.propTypes = {
  router: propTypes.any,
  children: propTypes.node
} : void 0;
Router.defaultProps = {
  router: undefined,
  children: undefined
};
export default Router;